
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15181.649 17068.352 12.1 13.299"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_194_6","data-name":"Symbol 194 – 6","transform":"translate(5292 853)","opacity":".64"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3662","d":"M3.64 13.26h8.16a.255.255 0 0 0 .24-.24V3.74a.255.255 0 0 0-.24-.24H3.64a.255.255 0 0 0-.24.24v9.28a.255.255 0 0 0 .24.24z","data-name":"Path 3662","transform":"translate(-20474.24 16214.74)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3663","d":"M9.58.7H1.02C.86.7.7.7.7.86v9.84","data-name":"Path 3663","transform":"translate(-20473.699 16215.3)"}})])])
          )
        }
      }
    